/*
  Resource Manifest Reducer + action definitions
*/
import { LOGOUT } from 'data_system/token_auth/actionTypes';

import {
  UPDATE_SLOT_FILTER,
  FETCH_SLOTS_REQUEST,
  FETCH_SLOTS_SUCCESS,
  FETCH_SLOTS_FAILURE,
  CHANGE_PAGE,
  FETCH_MORE_SLOTS_REQUEST,
  FETCH_MORE_SLOTS_SUCCESS,
  FETCH_MORE_SLOTS_FAILURE,
  FETCH_SLOT_REQUEST,
  FETCH_SLOT_SUCCESS,
  FETCH_SLOT_FAILURE,
  LOAD_UNBOOKED_SLOT,
  CANCEL_SLOT_REQUEST,
  CANCEL_SLOT_SUCCESS,
  CANCEL_SLOT_FAILURE,
  SHOW_NOTIFICATION,
} from '../actions/slotsActionTypes';
// =====

// Initial state to initialize reducer
const initialState = {
  // Multiple slots list view
  slots: [],
  slotsFetching: false,
  slotsFetchingError: false,
  slotFilter: 'upcoming',
  page: 1,
  totalPages: 1,
  moreSlotsFetching: false,
  // Single slot details view
  slot: {},
  slotFetching: false,
  slotFetchingError: false,
  // Slot cancellation
  slotCancelling: false,
  slotCancellingError: false,
  slotNotice: null,
  slotNoticeType: 'notice',
};

export function slotsReducer(state = initialState, action) {
  switch (action.type) {
    case LOGOUT:
      return { ...initialState };

    // A lot of state needs to be reset when changing the filter between upcoming/past
    case UPDATE_SLOT_FILTER:
      return {
        ...state,
        slotFilter: action.slotFilter,
        slots: [],
        page: 1,
        totalPages: 1,
      };

    // Fetching a List of upcoming/past slots =====
    case FETCH_SLOTS_REQUEST:
      return {
        ...state,
        slotsFetching: true,
        slotsFetchingError: false,
        page: 1,
      };
    case FETCH_SLOTS_SUCCESS:
      return {
        ...state,
        slots: action.slots,
        totalPages: action.totalPages,
        slotsFetching: false,
      };
    case FETCH_SLOTS_FAILURE:
      return {
        ...state,
        slots: [],
        slotsFetching: false,
        slotsFetchingError: action.error,
      };
    // =====

    // Pagination
    case CHANGE_PAGE:
      return { ...state, page: action.page };

    // Appending the infinite scroll list with more slots
    case FETCH_MORE_SLOTS_REQUEST:
      return { ...state, moreSlotsFetching: true };
    case FETCH_MORE_SLOTS_SUCCESS: {
      const slots = [...state.slots, ...action.slots];
      return {
        ...state,
        slots,
        page: action.page,
        totalPages: action.totalPages,
        moreSlotsFetching: false,
        slotsFetching: false,
      };
    }
    case FETCH_MORE_SLOTS_FAILURE:
      return {
        ...state,
        moreSlotsFetching: false,
        slotsFetchingError: action.error,
      };
    // =====

    // Fetching a single slot for SlotDetails =====
    case FETCH_SLOT_REQUEST:
      return { ...state, slotFetching: true, slotFetchingError: false };
    case FETCH_SLOT_SUCCESS:
      return {
        ...state,
        slot: action.slot,
        slotFetching: false,
      };
    case FETCH_SLOT_FAILURE:
      return {
        ...state,
        slot: {},
        slotFetching: false,
        slotFetchingError: action.error,
      };

    // Slot Cancellation on SlotDetails =====
    case CANCEL_SLOT_REQUEST:
      return {
        ...state,
        slotCancelling: true,
        slotCancellingError: false,
        slotCancellingNotice: null,
      };
    case CANCEL_SLOT_SUCCESS:
      return {
        ...state,
        slotCancelling: false,
        slotCancellingError: false,
        slotCancellingNotice: '.',
        slotCancellingNoticeType: '',
      };
    case CANCEL_SLOT_FAILURE:
      return {
        ...state,
        slotCancelling: false,
        slotCancellingError: action.error,
        slotCancellingNotice: '.',
        slotCancellingNoticeType: 'error',
      };

    case SHOW_NOTIFICATION:
      return {
        ...state,
        slotNotice: action.notice,
        slotNoticeType: action.noticeType,
      };
    // =====

    case LOAD_UNBOOKED_SLOT:
      return { ...state, slot: action.slot };

    default:
      return state;
  }
}
